import { render, staticRenderFns } from "./StudentDetail.vue?vue&type=template&id=18e63e40&scoped=true"
import script from "./StudentDetail.vue?vue&type=script&lang=js"
export * from "./StudentDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentDetail.vue?vue&type=style&index=0&id=18e63e40&prod&scoped=true&lang=css"
import style1 from "./StudentDetail.vue?vue&type=style&index=1&id=18e63e40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e63e40",
  null
  
)

export default component.exports